<template>
  <div class="homePage">
    <component :is="userCover" :info="coverInfo" />
    <q-inner-loading :showing="visible" />
    <!-- <Bottom :status="coverInfo.status" /> -->
  </div>
</template>

<script>
import { getCoverPage } from 'src/api/home';
import { getTable } from 'src/utils/common';
import { BasicCover, DefaultCover, KitchenCover } from './theme/index';
import { createMeta } from './meta.js';
// import { Bottom } from './components/index';

export default {
  name: 'PageIndex',
  components: {
    BasicCover,
    DefaultCover,
    KitchenCover,
    // Bottom,
  },
  meta() {
    return createMeta(this);
  },
  data() {
    return {
      userCover: null,
      markers: [],
      coverInfo: {},
      visible: true,
      store2theme: {
        ykitchen: 'KitchenCover',
        // test: 'KitchenCover',
      },
    };
  },
  created() {
    this.userCover = this.store2theme[this.storeInfo.url] || 'DefaultCover';
    getCoverPage().then((res) => {
      this.coverInfo = res.data;
    });
  },
  mounted() {
    // update table to url
    const table = getTable();
    if (!this.$route.query.table && table) {
      this.$router.replace({
        path: `${this.$route.params.store}`,
        query: { table },
      });
    }
    if (this.$route.query.mdn) {
      this.$store.dispatch('Menu/setAccount', this.$route.query.mdn)
    }
  },
  updated() {
    this.$nextTick(() => {
      this.visible = false;
    });
  },
};
</script>
<style lang="scss" scoped>
.homePage {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: Montserrat;
  background: $grayBg;
  overflow: hidden;
}
</style>
